const DeviceStatus = Object.freeze({
    OK: 'OK',
    NEUTRAL: 'NEUTRAL',
    WARN: 'WARN',
    ERROR: 'ERROR',
});
export default DeviceStatus;
